import { useState, useEffect } from 'react';

import getValidChartDotsNumber from 'components/data-visualization/DoubleChart/utils/getValidChartDotsNumber';

const useTrendData = (data: any): any => {
  const [trendData, setTrendData] = useState();
  useEffect(() => {
    if (data.fulfilled && !data.value) return;

    if (data?.value?.length > 0) {
      setTrendData(
        data?.value[0].playlists.length > 0
          ? getValidChartDotsNumber(data?.value[0].playlists[0].data)
          : null
      );
    }
  }, [data]);

  return trendData;
};

export default useTrendData;
